import { MailOutlined } from '@ant-design/icons';
import { Button, message, Tooltip } from 'antd';
import React, { useState } from 'react';

import { fetchAPI } from '../../utils/api';
import { RFITicket } from './types';

const RFISupplierEmailButton = (props: { record: RFITicket }) => {
  const [loading, setLoading] = useState(false);

  const sendSupplierEmail = async () => {
    if (!props.record.supplier_id) {
      return;
    }

    const actionByEmail = props.record.action_by?.username;
    if (!actionByEmail) {
      message.error('Assigned staff email not found');
      return;
    }

    setLoading(true);
    try {
      const resp = await fetchAPI(
        `supplier/${props.record.supplier_id}/rfi-ticket/${props.record.id}/email`,
        {
          method: 'POST',
          payload: {
            emails: [actionByEmail],
          },
        }
      );

      message.success(
        `${resp?.msg || 'Success trigger email'}${
          resp?.ticket_number ? ` (${resp.ticket_number})` : ''
        }`
      );
    } catch (error) {
      message.error('Failed send RFI info email');
      if (error.message) {
        message.error(error.message);
      }
    }
    setLoading(false);
  };

  return (
    <Tooltip
      title={
        props.record.supplier_id
          ? 'Send RFI info email to supplier'
          : 'Supplier is required to send email'
      }
    >
      <Button
        icon={<MailOutlined />}
        loading={loading}
        disabled={!props.record.supplier_id}
        onClick={() => sendSupplierEmail()}
        size="small"
      >
        Send RFI Info
      </Button>
    </Tooltip>
  );
};

export default RFISupplierEmailButton;
